// extracted by mini-css-extract-plugin
export default {"notificationNewClientFavorite":"styles_notificationNewClientFavorite__zExVI","price":"styles_price__B5ezH"};